import React, { useState } from "react";
import "./ServiceTypeSelector.css";

function ServiceTypeSelector({ onSelect, uiCfg = {} }) {
  const [acknowledged, setAcknowledged] = useState(false);
  const disclaimer = uiCfg?.ui?.serviceTypeDisclaimer;

  // Render disclaimer gate if disclaimer is configured and not yet acknowledged
  if (disclaimer && !acknowledged) {
    return (
      <div className="service-selector-container service-selector-container-centered">
        <div className="service-selector-card">
          <h1 className="serviceTypeTitle">Service Request Estimator</h1>
          <p className="serviceTypeLede">
            Please read and acknowledge the following disclaimer before continuing:
          </p>
          
          <div className="service-disclaimer">
            {disclaimer.split('\n').map((line, i) => {
              const lines = disclaimer.split('\n');
              const isStrong = line.startsWith('**') && line.endsWith('**');
              const prevLineIsStrong = i > 0 && lines[i-1].startsWith('**') && lines[i-1].endsWith('**');
              const showBreak = i < lines.length - 1 && !isStrong && !prevLineIsStrong;
              
              return (
                <React.Fragment key={i}>
                  {isStrong ? (
                    <strong>{line.slice(2, -2)}</strong>
                  ) : (
                    line
                  )}
                  {showBreak && <br />}
                </React.Fragment>
              );
            })}
          </div>

          <button 
            className="svcTypeBtn service-acknowledge-btn" 
            onClick={() => setAcknowledged(true)}
          >
            I Acknowledge & Continue
          </button>
        </div>
      </div>
    );
  }

  // Render service type selection after acknowledgment (or if no disclaimer)
  return (
    <div className="service-selector-container">
      <div className="service-selector-card">
        <h1 className="serviceTypeTitle">Service Request Estimator</h1>
        <p className="serviceTypeLede">
          Please select the type of service you're requesting:
        </p>
        <div className="svcTypeGrid">
          <button className="svcTypeBtn" onClick={() => onSelect("Residential")}>Residential</button>
          <button className="svcTypeBtn" onClick={() => onSelect("Irrigation")}>Irrigation</button>
          <button className="svcTypeBtn" onClick={() => onSelect("Commercial")}>Commercial</button>
        </div>
      </div>

      <div className="service-selector-logo">
        <img
          src="/themes/default/branding/logo-full.png"
          alt="Service Estimator"
        />
      </div>
    </div>
  );
}

export default ServiceTypeSelector;
